
import { Card, CardContent } from "@/components/ui/card";
import { DataOneStyleData } from "@/types/dataone";
import { DataOneUtils } from "./utils";

interface ColorsMaterialsProps {
  colorInfo?: {
    exterior: DataOneStyleData[];
    interior: DataOneStyleData[];
  };
  data?: any; // Optional data parameter for backward compatibility
  selectedStyle?: any;
  selectedStyleIndex?: number;
}

export const ColorsMaterials = ({ colorInfo, data, selectedStyle, selectedStyleIndex }: ColorsMaterialsProps) => {
  // Extract color information based on selection or from data if not directly provided
  let extractedColors = null;
  
  if (selectedStyle) {
    // Try to get colors directly from the selected style
    const exteriorColors = selectedStyle.colors?.exterior_colors?.color || [];
    const interiorColors = selectedStyle.colors?.interior_colors?.color || [];
    
    extractedColors = {
      exteriorColors: Array.isArray(exteriorColors) ? exteriorColors : [exteriorColors].filter(Boolean),
      interiorColors: Array.isArray(interiorColors) ? interiorColors : [interiorColors].filter(Boolean)
    };
  } else {
    // Fall back to utility function for getting colors from overall data
    extractedColors = data ? DataOneUtils.extractColorsMaterials(data) : null;
  }
  
  // Normalize data structure to handle both naming formats
  const colors = colorInfo || (extractedColors ? {
    exterior: extractedColors.exteriorColors || [],
    interior: extractedColors.interiorColors || []
  } : { exterior: [], interior: [] });
  
  if (!colors || (!colors.exterior.length && !colors.interior.length)) {
    return (
      <div className="text-gray-500">No color information available</div>
    );
  }

  return (
    <div className="space-y-6">
      {colors.exterior.length > 0 && (
        <div>
          <h3 className="text-lg font-medium text-gray-800 mb-3">Exterior Colors</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {colors.exterior.map((color, index) => (
              <Card key={index} className="overflow-hidden">
                <CardContent className="p-4">
                  <div className="font-medium">{color.name}</div>
                  {color.description && color.description !== color.name && (
                    <p className="text-sm text-gray-600 mt-1">{color.description}</p>
                  )}
                  {color.price && (
                    <div className="text-sm text-gray-500 mt-2">
                      Price: ${color.price}
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      )}

      {colors.interior.length > 0 && (
        <div>
          <h3 className="text-lg font-medium text-gray-800 mb-3">Interior Colors</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {colors.interior.map((color, index) => (
              <Card key={index} className="overflow-hidden">
                <CardContent className="p-4">
                  <div className="font-medium">{color.name}</div>
                  {color.description && color.description !== color.name && (
                    <p className="text-sm text-gray-600 mt-1">{color.description}</p>
                  )}
                  {color.price && (
                    <div className="text-sm text-gray-500 mt-2">
                      Price: ${color.price}
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
